export const GET_CAREER = "GET_CAREER";
export const GET_SUCCESS_CAREER = "GET_SUCCESS_CAREER";
export const GET_FAIL_CAREER = "GET_FAIL_CAREER";

export function getCareer() {
  return {
    type: GET_CAREER
  }
}
